import { getCurrentUser } from "../getCurrentUser";
import { shouldMockApis } from "../shouldMockApis";
import { getAppInsightsClient } from "./AppInsightsClient";
import { ConsoleLogger } from "./ConsoleLogger";

export class Log {
  private static loggerInstance: ConsoleLogger = new ConsoleLogger("DinLabel");
  private static initialized = false;

  static get logger(): ConsoleLogger {
    return this.loggerInstance;
  }

  /** Enable App Insights in production (non-localhost). Safe to call once at startup. */
  static initializeTelemetry(): void {
    if (Log.initialized) {
      return;
    }
    Log.initialized = true;

    const client = getAppInsightsClient();
    const enabled = !shouldMockApis();
    client.setEnabled(enabled);
    client.setAuthenticatedUser(getCurrentUser()?.UserId);

    if (enabled) {
      client.trackEvent("WebAppStart", {});
    }
  }
}
